import { Extension } from "@tiptap/core";
import { EditorState, Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { highlightCss } from "./ListenModeHighlightDecorator.style";

export const listenModeHighlightDecoratorPluginKey = new PluginKey(
  "listenModeHighlightDecorator",
);

export const ListenModeHighlightDecorator = Extension.create({
  name: "listenModeHighlightDecorator",
  group: "inline",
  inline: true,
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: listenModeHighlightDecoratorPluginKey,
        state: {
          init() {
            return { metadata: null };
          },
          apply(tr, value) {
            const meta = tr.getMeta(listenModeHighlightDecoratorPluginKey);
            if (meta) {
              return { metadata: meta };
            }
            return value;
          },
        },
        props: {
          decorations: (state: EditorState) => {
            const { doc } = state;
            const pluginState =
              listenModeHighlightDecoratorPluginKey.getState(state);
            const meta = pluginState.metadata;

            if (meta) {
              const { start, value } = meta;
              const startIndex: number = Number(start);
              const endIndex = startIndex + value?.length;
              const endIndexToUse: number =
                (endIndex || 0) > doc?.content?.size
                  ? doc?.content?.size
                  : endIndex;

              if (startIndex >= 0 && startIndex < endIndexToUse) {
                const adjustedEnd = Math.min(
                  startIndex + value?.length,
                  doc.content.size,
                );

                return DecorationSet.create(doc, [
                  Decoration.inline(startIndex, adjustedEnd, {
                    class: highlightCss,
                  }),
                ]);
              }
            } else {
              return DecorationSet.empty;
            }

            return null;
          },
        },
      }),
    ];
  },
});
